/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/AngleLeft': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M10.048 16L22.41 5.586a.25.25 0 0 0 .03-.352l-.97-1.146a.25.25 0 0 0-.352-.029L7.855 15.235c-.473.4-.473 1.13 0 1.53L21.119 27.94c.105.09.263.077.352-.029l.97-1.145a.251.251 0 0 0-.03-.353L10.048 16z"/>'
  }
})
